import { FormDefinitionType } from '@/api/dtos';

export interface EConsentFormRegistration {
    code: string;
    requestTypeName: string;
    formDefinitionId: FormDefinitionType;
    picfTypeId: number;
}

export const mainConsentEConsentRegistration: EConsentFormRegistration = {
    code: 'main-consent',
    requestTypeName: 'MainConsentForm',
    formDefinitionId: FormDefinitionType.MainConsentForm,
    picfTypeId: 1,
};

export const optionalConsentEConsentRegistration: EConsentFormRegistration = {
    code: 'optional-consent',
    requestTypeName: 'OptionalConsentForm',
    formDefinitionId: FormDefinitionType.OptionalConsentForm,
    picfTypeId: 2,
};

export const servicesAustraliaConsentEConsentRegistration: EConsentFormRegistration = {
    code: 'services-australia-consent',
    requestTypeName: 'ServicesAustraliaConsentForm',
    formDefinitionId: FormDefinitionType.ServicesAustraliaConsentForm,
    picfTypeId: 3,
};

const eConsentFormRegistrations: Record<string, EConsentFormRegistration> = {
    [mainConsentEConsentRegistration.code]: mainConsentEConsentRegistration,
    [optionalConsentEConsentRegistration.code]: optionalConsentEConsentRegistration,
    [servicesAustraliaConsentEConsentRegistration.code]: servicesAustraliaConsentEConsentRegistration,
};

export const getEConsentFormRegistration = (formCode?: string) =>
    formCode ? eConsentFormRegistrations[formCode] : undefined;

export default eConsentFormRegistrations;
